import { SafeImg } from './ScrollReveal';

const comments = [
  {
    name: '漫友小林',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20soft%20background%2C%20flat%20illustration%20style%2C%20warm%20coral%20tones&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '3天前',
    content: '用了99漫画快两年了，下拉式阅读真的太爽了！尤其是看韩漫的时候，画面连贯性特别好。更新速度也快，基本汉化出来当天就能看到。推荐给了好几个朋友，都说好用！',
    likes: 128,
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20avatar%20of%20a%20person%20with%20glasses%2C%20simple%20soft%20background%2C%20flat%20illustration%20style%2C%20warm%20amber%20tones&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '1周前',
    content: '收藏功能很实用，我的书架里已经攒了两百多部了。追更提醒从来没漏过，每次更新都能第一时间看到。日漫和国漫的资源也很全，找什么基本都有。希望继续加油！',
    likes: 96,
  },
  {
    name: '追更少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sweet%20anime%20style%20avatar%20of%20a%20young%20girl%20with%20long%20hair%2C%20simple%20soft%20background%2C%20flat%20illustration%20style%2C%20warm%20peach%20tones&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '2周前',
    content: '从别的平台转过来的，99漫画的分类做得真的清楚。恋爱甜宠区的韩漫太戳我了！而且完全免费这点真的良心。推荐大家下载APP，晚上开深色模式看漫画眼睛不累，体验感满分~',
    likes: 215,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-accent-100 text-accent-800 mb-3 whitespace-nowrap">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫友评价
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            听听漫画爱好者们怎么说99漫画
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <SafeImg
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-400"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}